import { clone } from 'rambda';
import { TemplateElement } from '@bynder-studio/render-core';

type Element = {
    id: number;
    properties: {
        hidden: boolean;
        locked: boolean;
        allowToggleVisibility: boolean;
    };
    children?: Element[];
};

const filterElementsRecursively = <TElement extends Element>(elements: TElement[]): TemplateElement => {
    let obj = {} as TemplateElement;

    elements.forEach((el) => {
        const { hidden, locked, allowToggleVisibility } = el.properties;

        // todo: Remove after BE implements inherited locks
        // if ((hidden && !allowToggleVisibility) || locked) {
        if (hidden && !allowToggleVisibility) {
            return;
        }

        if ('children' in el && el.children?.length) {
            obj = { ...obj, ...filterElementsRecursively(el.children) };
        } else {
            obj[el.id] = el;
        }
    });

    return obj;
};

 
export const getVisibleElements = <TElement extends Element>(
    pages: { elements: TElement[] },
    selectedPageIdx: number,
): TemplateElement => filterElementsRecursively(clone(pages[selectedPageIdx].elements));
